/**
 * anything that relates to DOM
 */
export default {
  namespaced: true,
  state: {
    isLoadingApp: true,
    isInitLoadingApp: true
  },
  mutations: {
    SET_LOADING_APP (state, value) {
      state.isLoadingApp = value
      state.isInitLoadingApp = !value ? value : state.isInitLoadingApp
    }
  },
  getters: {
    isLoadingApp: state => {
      return state.isLoadingApp
    },
    isInitLoadingApp: state => {
      return state.isInitLoadingApp
    }
  }
}
